import React from "react";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";

import styles from "./glassy-modal-header.module.scss";

interface GlassyModalHeaderPropTypes {
  title: string;
  leftIcon?: string;
  leftIconFunction?: () => void;
  rightIcon?: string;
  rightIconFunction?: () => void;
}

const cssClassName = "glassy-modal-header";

export const GlassyModalHeader = ({
  title,
  leftIcon,
  leftIconFunction,
  rightIcon,
  rightIconFunction,
}: GlassyModalHeaderPropTypes) => {
  const renderIconOrFragment = (icon, callback) => {
    if (icon) {
      return <IconButton fun={callback} icon={icon} />;
    }
    return <div className={styles[`${cssClassName}__placeholder`]}></div>;
  };

  return (
    <div className={styles[cssClassName]}>
      {renderIconOrFragment(leftIcon, leftIconFunction)}
      <SubTitle text={title} />
      {renderIconOrFragment(rightIcon, rightIconFunction)}
    </div>
  );
};
